var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadAndroidLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 48,
    viewBox: "0 0 162 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M156 48H6C2.6 48 0 45.4 0 42V6C0 2.6 2.6 0 6 0H156C159.4 0 162 2.6 162 6V42C162 45.4 159.4 48 156 48Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M156 1C158.8 1 161 3.3 161 6V42C161 44.8 158.7 47 156 47H6C3.2 47 1 44.7 1 42V6C1 3.2 3.3 1 6 1H156ZM156 0H6C2.6 0 0 2.8 0 6V42C0 45.4 2.6 48 6 48H156C159.4 48 162 45.4 162 42V6C162 2.8 159.4 0 156 0Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9 12.2C56.9 13.2 56.7 14 56.1 14.6C55.4 15.3 54.5 15.7 53.5 15.7C52.4 15.7 51.6 15.3 50.9 14.6C50.2 13.9 49.8 13 49.8 12C49.8 11 50.2 10.1 50.9 9.39999C51.6 8.69999 52.5 8.29999 53.5 8.29999C54 8.29999 54.5 8.39999 54.9 8.69999C55.4 8.89999 55.7 9.19999 56 9.49999L55.4 10.1C54.9 9.49999 54.3 9.29999 53.5 9.29999C52.8 9.29999 52.1 9.49999 51.6 10.1C51 10.6 50.8 11.3 50.8 12.1C50.8 12.9 51 13.7 51.6 14.1C52.2 14.6 52.8 14.9 53.5 14.9C54.3 14.9 54.9 14.7 55.5 14.1C55.9 13.7 56.1 13.3 56.1 12.7H53.5V11.7H57V12.2H56.9ZM62.4 9.19999H59.2V11.5H62.2V12.3H59.2V14.6H62.4V15.6H58.2V8.39999H62.4V9.19999ZM66.4 15.6H65.4V9.19999H63.4V8.39999H68.4V9.19999H66.4V15.6ZM71.9 15.6V8.39999H72.9V15.6H71.9ZM76.9 15.6H75.9V9.19999H73.9V8.39999H78.8V9.19999H76.8V15.6H76.9ZM88.3 14.6C87.6 15.3 86.7 15.7 85.7 15.7C84.7 15.7 83.8 15.3 83.1 14.6C82.3 13.9 82 13.1 82 12C82 10.9 82.4 10.1 83.1 9.39999C83.8 8.69999 84.7 8.29999 85.7 8.29999C86.7 8.29999 87.6 8.69999 88.3 9.39999C89 10.1 89.4 11 89.4 12C89.4 13 89 13.9 88.3 14.6ZM83.8 14C84.3 14.5 85 14.8 85.7 14.8C86.4 14.8 87.1 14.6 87.6 14C88.1 13.5 88.4 12.8 88.4 12C88.4 11.2 88.2 10.4 87.6 9.99999C87.1 9.49999 86.4 9.19999 85.7 9.19999C85 9.19999 84.3 9.39999 83.8 9.99999C83.3 10.5 83 11.2 83 12C82.9 12.8 83.2 13.6 83.8 14ZM90.7 15.6V8.39999H91.8L95.3 14V8.39999H96.3V15.6H95.3L91.6 9.69999V15.6H90.7Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2222,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7 26.2C78.8 26.2 76.5 28.4 76.5 31.4C76.5 34.3 78.8 36.6 81.7 36.6C84.6 36.6 86.9 34.4 86.9 31.4C86.9 28.2 84.6 26.2 81.7 26.2ZM81.7 34.3C80.1 34.3 78.8 33 78.8 31.2C78.8 29.4 80.1 28.1 81.7 28.1C83.3 28.1 84.6 29.3 84.6 31.2C84.6 33 83.3 34.3 81.7 34.3ZM70.6 26.2C67.7 26.2 65.4 28.4 65.4 31.4C65.4 34.3 67.7 36.6 70.6 36.6C73.5 36.6 75.8 34.4 75.8 31.4C75.7 28.2 73.4 26.2 70.6 26.2ZM70.6 34.3C69 34.3 67.7 33 67.7 31.2C67.7 29.4 69 28.1 70.6 28.1C72.2 28.1 73.5 29.3 73.5 31.2C73.4 33 72.1 34.3 70.6 34.3ZM57.2 27.7V29.9H62.4C62.3 31.1 61.8 32.1 61.2 32.7C60.5 33.4 59.3 34.3 57.2 34.3C54 34.3 51.6 31.8 51.6 28.5C51.6 25.2 54.1 22.7 57.2 22.7C58.9 22.7 60.2 23.4 61.2 24.3L62.8 22.7C61.5 21.5 59.8 20.5 57.4 20.5C53.1 20.5 49.4 24.1 49.4 28.4C49.4 32.7 53.1 36.3 57.4 36.3C59.8 36.3 61.5 35.6 62.9 34C64.3 32.6 64.8 30.5 64.8 29C64.8 28.5 64.8 28 64.7 27.7H57.2ZM111.7 29.4C111.2 28.2 110 26.2 107.4 26.2C104.8 26.2 102.6 28.2 102.6 31.4C102.6 34.3 104.8 36.6 107.6 36.6C109.9 36.6 111.3 35.2 111.8 34.3L110.1 33.1C109.5 33.9 108.8 34.5 107.6 34.5C106.4 34.5 105.7 34 105.1 32.9L112 30L111.7 29.4ZM104.8 31.1C104.8 29.2 106.4 28.1 107.4 28.1C108.2 28.1 109.1 28.6 109.3 29.2L104.8 31.1ZM99.1 36H101.4V21H99.1V36ZM95.5 27.2C94.9 26.6 94 26 92.8 26C90.3 26 87.9 28.3 87.9 31.2C87.9 34.1 90.2 36.2 92.8 36.2C94 36.2 95 35.6 95.4 35H95.5V35.7C95.5 37.6 94.4 38.7 92.7 38.7C91.4 38.7 90.4 37.7 90.2 36.9L88.3 37.7C88.9 39 90.3 40.7 92.9 40.7C95.5 40.7 97.7 39.1 97.7 35.4V26.3H95.5V27.2ZM92.9 34.3C91.3 34.3 90 33 90 31.2C90 29.4 91.3 28.1 92.9 28.1C94.5 28.1 95.7 29.4 95.7 31.2C95.7 33 94.4 34.3 92.9 34.3ZM122.2 21H116.8V36H119.1V30.4H122.2C124.7 30.4 127.1 28.6 127.1 25.7C127.1 22.8 124.7 21 122.2 21ZM122.3 28.2H119V23H122.2C123.9 23 124.8 24.4 124.8 25.5C124.8 26.9 123.8 28.2 122.3 28.2ZM136.1 26C134.4 26 132.7 26.7 132.1 28.3L134.1 29.1C134.6 28.3 135.3 28 136.1 28C137.3 28 138.4 28.7 138.5 29.9V30C138.1 29.8 137.2 29.4 136.2 29.4C134 29.4 131.9 30.6 131.9 32.8C131.9 34.8 133.7 36.2 135.6 36.2C137.2 36.2 137.9 35.5 138.5 34.8H138.6V36H140.8V30.2C140.6 27.6 138.6 26 136.1 26ZM135.8 34.3C135.1 34.3 134 33.9 134 33C134 31.8 135.3 31.4 136.4 31.4C137.4 31.4 137.8 31.6 138.4 31.9C138.2 33.4 137 34.3 135.8 34.3ZM148.4 26.4L145.9 32.9H145.8L143.2 26.4H140.8L144.8 35.5L142.5 40.5H144.8L150.9 26.3H148.4V26.4ZM128.3 36H130.6V21H128.3V36Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4852 9.0296C12.0852 9.4296 11.9852 10.0296 11.9852 10.7296V37.2296C11.9852 37.9296 12.1852 38.5296 12.5852 38.9296L12.6852 39.0296L27.5852 24.1296V23.9296L12.4852 9.0296Z",
    fill: "url(#paint0_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3852 29.1296L27.4852 24.2296V23.8296L32.3852 18.9296L32.4852 19.0296L38.3852 22.4296C40.0852 23.4296 40.0852 24.9296 38.3852 25.9296L32.3852 29.1296Z",
    fill: "url(#paint1_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4852 29.0296L27.4852 24.0296L12.4852 39.0296C13.0852 39.6296 13.8852 39.6296 14.9852 39.1296L32.4852 29.0296Z",
    fill: "url(#paint2_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4852 18.9296L14.9852 8.9296C13.8852 8.3296 13.0852 8.4296 12.4852 9.0296L27.4852 23.9296L32.4852 18.9296Z",
    fill: "url(#paint3_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M32.3852 28.9296L14.9852 38.7296C13.9852 39.3296 13.1852 39.2296 12.5852 38.7296L12.4852 38.8296L12.5852 38.9296C13.1852 39.4296 13.9852 39.5296 14.9852 38.9296L32.3852 28.9296Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M12.4852 38.7296C12.0852 38.3296 11.9852 37.7296 11.9852 37.0296V37.1296C11.9852 37.8296 12.1852 38.4296 12.5852 38.8296V38.7296H12.4852ZM38.3852 25.5296L32.3852 28.9296L32.4852 29.0296L38.3852 25.6296C39.1852 25.1296 39.5852 24.5296 39.5852 23.9296C39.5852 24.6296 39.0852 25.1296 38.3852 25.5296Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M14.9852 9.12959L38.3852 22.4296C39.0852 22.9296 39.5852 23.4296 39.5852 24.0296C39.5852 23.4296 39.1852 22.8296 38.3852 22.3296L14.9852 9.02959C13.2852 8.02959 11.9852 8.82959 11.9852 10.7296V10.8296C11.9852 9.02959 13.2852 8.12959 14.9852 9.12959Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 21.6081,
    y1: 10.5066,
    x2: 8.81587,
    y2: 23.2988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 40.5871,
    y1: 24.0755,
    x2: 11.5512,
    y2: 24.0755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 28.4334,
    y1: 27.4372,
    x2: 6.64701,
    y2: 49.2254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 7.38583,
    y1: 8.16574,
    x2: 17.0815,
    y2: 17.8605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadAndroidLogo);
export default __webpack_public_path__ + "static/media/DownloadAndroidLogo.d84e4233d1e5f30d8f850cc180b086e8.svg";
export { ForwardRef as ReactComponent };